import React, { useState } from "react";
import { Modal } from "@mantine/core";
import { useResponsive } from "../../../context/ResponsiveContext";
import { StaffForm, StaffFormProps } from "./StaffForm";
import styles from "./StaffFormModal.module.css";

export interface StaffFormModalProps extends Omit<
  StaffFormProps,
  "onSavingChange"
> {
  opened: boolean;
  onClose: () => void;
  title: string;
}

/**
 * The staff form in its modal: a 720px dialog on desktop, full screen on
 * mobile. Closing is locked while a save is in flight.
 */
export function StaffFormModal({
  opened,
  onClose,
  title,
  ...formProps
}: StaffFormModalProps) {
  const { isMobile } = useResponsive();
  const [isSaving, setIsSaving] = useState(false);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      size={720}
      radius={isMobile ? 0 : 12}
      padding="lg"
      centered
      fullScreen={isMobile}
      closeOnClickOutside={!isSaving}
      closeOnEscape={!isSaving}
      withCloseButton={!isSaving}
      overlayProps={{ backgroundOpacity: 0.35, color: "#141414" }}
      classNames={{
        content: isMobile
          ? `${styles.content} ${styles.contentFullScreen}`
          : styles.content,
        title: styles.title,
        body: styles.body,
      }}
    >
      <StaffForm {...formProps} onSavingChange={setIsSaving} />
    </Modal>
  );
}
